import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';

// render - dashboard pages
// const DefaultPages = Loadable(lazy(() => import('views/navigation/dashboard/Default')));
const Users = Loadable(lazy(() => import('views/users/Users')));
const Report = Loadable(lazy(() => import('views/report/Report')));
const Warehouse = Loadable(lazy(() => import('views/warehouse/Warehouse')));
const Product = Loadable(lazy(() => import('views/product/Product')));
const PurchaseOrder = Loadable(lazy(() => import('views/purchaseOrder/PurchaseOrder')));
const SalesOrder = Loadable(lazy(() => import('views/salesOrder/SalesOrder')));
const GoodsReceipt = Loadable(lazy(() => import('views/goodsReceipt/GoodsReceipt')));
const Inventory = Loadable(lazy(() => import('views/inventory/Inventory')));
const DispatchOrder = Loadable(lazy(() => import('views/dispatchOrder/DispatchOrder')));
const Supplier = Loadable(lazy(() => import('views/supplier/Supplier')));
const AuditLog = Loadable(lazy(() => import('views/auditLog/AuditLog')));

// ==============================|| NAVIGATION ROUTING ||============================== //

const NavigationRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: '/',
          element: <Report />
        },
        {
          path: '/warehouse',
          element: <Warehouse />
        },
        {
          path: '/product',
          element: <Product />
        },
        {
          path: '/purchase-order',
          element: <PurchaseOrder />
        },
        {
          path: '/sales-order',
          element: <SalesOrder />
        },
        {
          path: '/goods-receipt',
          element: <GoodsReceipt />
        },
        {
          path: '/inventory',
          element: <Inventory />
        },
        {
          path: '/dispatch-order',
          element: <DispatchOrder />
        },
        {
          path: '/supplier',
          element: <Supplier />
        },
        {
          path: '/users',
          element: <Users />
        },
        {
          path: '/audit-log',
          element: <AuditLog />
        }
      ]
    }
  ]
};

export default NavigationRoutes;
